// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.

import React, { useState, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import Header from "../../component/_elements/Header.tsx";
import { useReactToPrint } from "react-to-print";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  personalAttendanceController,
  PonctualitePersonalType,
  PonctualiteType,
  studentAttendanceController,
} from "../../_api/controllers/attendance.controller.ts";
import {
  classeController,
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import {
  studentControler,
  StudentType,
} from "../../_api/controllers/student.controller.ts";
import moment from "moment";
import { capitalizeFirstLetter } from "../../_services/utils.jsx";
import toast from "react-hot-toast";
import {
  personalController,
  PersonalType,
} from "../../_api/controllers/personal.controller.ts";
import { table } from "console";
// import "./styles.css";

const Attendance: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };
  // États pour la gestion des présences
  const [selectedDate, setSelectedDate] = useState<string>(
    moment().format("YYYY-MM-DD")
  );

  // console.log(selectedDate);

  const [selectedClass, setSelectedClass] =
    useState<string>("Toutes les classes");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<any>("tous");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(10);
  const [isJustifyModalOpen, setIsJustifyModalOpen] = useState<boolean>(false);
  const [isNotifyModalOpen, setIsNotifyModalOpen] = useState<boolean>(false);
  const [selectedStudent, setSelectedStudent] = useState<any>(null);
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const [notificationMessage, setNotificationMessage] = useState<string>("");

  const [justificationForm, setJustificationForm] = useState<{
    currentAttendanceCoteId: any;
    currentAttendanceId: any;
    reason: any;
  }>({
    currentAttendanceCoteId: null,
    currentAttendanceId: null,
    reason: null,
  });
  const [activeTab, setActiveTab] = useState<string>("students");
  const [selectedTeacher, setSelectedTeacher] = useState<any>(null);

  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Liste des élèves",
    pageStyle: `
      @page { size: A4; margin: 20mm }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          font-family: Arial, sans-serif;
        }
      }
    `,
  });

  //fetch eleves
  const { data: eleveData } = useQuery({
    queryKey: ["students"],
    queryFn: studentControler.getAll,
  });

  //fetch attendance of the current month
  const date = moment().format("YYYY-MM-DD");
  const { data: attendanceData } = useQuery({
    queryKey: ["studentAttendance"],
    queryFn: () => studentAttendanceController.getAllByMonth(date),
  });

  //fetch attendance of personal
  const { data: attendanceData_forPersonal } = useQuery({
    queryKey: ["personalAttendance"],
    queryFn: () => personalAttendanceController.getAll(),
  });

  //fetch promotion
  const { data: promotionsData } = useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });

  //fetch classe
  const { data: dataClasseObj } = useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });

  //fetch anne scolaire
  const { data: schoolYear } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });

  //fetch all Personnels
  const { data: personalsData } = useQuery({
    queryKey: ["personals"],
    queryFn: personalController.getAll,
  });

  const dataClasses = dataClasseObj?.data ? dataClasseObj.data : [];
  const dataPromotionArr = promotionsData?.data ? promotionsData.data : [];
  const attendanceDataArr_forStudent = attendanceData?.data
    ? attendanceData
    : [];
  const attendanceDataArr_forPersonal = attendanceData_forPersonal?.data
    ? attendanceData_forPersonal.data
    : [];
  const incompleteSudentsArr = eleveData?.data ? eleveData.data : [];
  const incompletePersonalArr = personalsData?.data ? personalsData.data : [];

  console.log(attendanceData);
  console.log(attendanceDataArr_forStudent);
  // console.log(incompletePersonalArr);

  // Selected data by date for Students and for Personal
  const attendancesDataByDate_forStudent: PonctualiteType[] =
    attendanceDataArr_forStudent.filter(
      (attendance: PonctualiteType) =>
        moment(attendance.created_at).format("YYYY-MM-DD") === selectedDate
    );
  const attendancesDataByDate_forPersonal: PonctualitePersonalType[] =
    attendanceDataArr_forPersonal.filter(
      (attendance) =>
        moment(attendance.created_at).format("YYYY-MM-DD") === selectedDate
    );

  //Create explicite dataArray for students and for personal
  let completeStudents: StudentType[] = incompleteSudentsArr.map((student) => {
    let parentData: any,
      promotionData: any,
      classeDesignation: any,
      classeId: any,
      coteJustification: any = null,
      coteHeureArrivee: any = null,
      coteEleveId: any = 3,
      coteId: any = null,
      coteCreatedAt: any = null;

    for (const promotion of dataPromotionArr) {
      if (
        promotion.annee_scolaire_id === schoolYear?.data[0].id &&
        promotion.eleve_id === student.eleve_id
      ) {
        promotionData = promotion;
        //it is possible to get all promotion of the current student here by handling the condition above
      }
    }
    for (const classe of dataClasses) {
      if (promotionData?.classe_id === classe.id) {
        classeDesignation = classe.designation;
        classeId = classe.id;
      }
    }

    for (const element of attendancesDataByDate_forStudent) {
      if (student.eleve_id === element.eleve_id) {
        coteEleveId = element.cote_eleve_id;
        coteId = element.id;
        coteJustification = element.justification;
        coteHeureArrivee = element.heure_arrivee;
        coteCreatedAt = element.created_at;
      }
    }

    return {
      ...student,
      parentData: parentData,
      promotionData: promotionData,
      classeDesignation: classeDesignation,
      classeId: classeId,
      coteId: coteId,
      coteEleveId: coteEleveId,
      coteJustification: coteJustification,
      coteHeureArrivee: coteHeureArrivee,
      coteCreatedAt,
    };
  });

  let completePersonals: PersonalType[] = incompletePersonalArr.map(
    (personal) => {
      let coteJustification: any = null,
        coteHeureArrivee: any = null,
        cotePersonalId: any = 3,
        coteId: any = null,
        coteCreatedAt: any = null;

      for (const element of attendancesDataByDate_forPersonal) {
        if (personal.personnel_id === element.personnel_id) {
          cotePersonalId = element.cote_enseignant_id;
          coteId = element.id;
          coteJustification = element.justification;
          coteHeureArrivee = element.heure_arrivee;
          coteCreatedAt = element.created_at;
        }
      }

      return {
        ...personal,
        coteId: coteId,
        cotePersonalId: cotePersonalId,
        coteJustification: coteJustification,
        coteHeureArrivee: coteHeureArrivee,
        coteCreatedAt,
      };
    }
  );

  console.log(completePersonals);

  const students: any = [...completeStudents];
  const teachers: any = [...completePersonals];

  // Données des enseignants (simulées)
  // const teachers = [
  //   {
  //     id: 1,
  //     nom: "Professeur Martin Dupont",
  //     matiere: "Mathématiques",
  //     classes: ["6ème A", "6ème B", "5ème A"],
  //     status: "present",
  //     arrivalTime: "",
  //     photo: null,
  //     absenceHistory: [
  //       {
  //         date: "2025-06-10",
  //         status: "absent",
  //         reason: "Formation",
  //         justified: true,
  //       },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     nom: "Madame Sophie Bernard",
  //     matiere: "Français",
  //     classes: ["4ème A", "4ème B", "4ème C"],
  //     status: "present",
  //     arrivalTime: "",
  //     photo: null,
  //     absenceHistory: [],
  //   },
  //   {
  //     id: 3,
  //     nom: "Monsieur Pierre Laurent",
  //     matiere: "Histoire-Géographie",
  //     classes: ["3ème A", "3ème B", "3ème C"],
  //     status: "absent",
  //     arrivalTime: "",
  //     photo: null,
  //     absenceHistory: [
  //       {
  //         date: "2025-06-20",
  //         status: "absent",
  //         reason: "Maladie",
  //         justified: true,
  //       },
  //       {
  //         date: "2025-06-15",
  //         status: "late",
  //         arrivalTime: "08:30",
  //         reason: "Transport",
  //         justified: true,
  //       },
  //     ],
  //   },
  //   {
  //     id: 4,
  //     nom: "Madame Julie Richard",
  //     matiere: "Sciences",
  //     classes: ["5ème A", "5ème B", "5ème C"],
  //     status: "late",
  //     arrivalTime: "08:15",
  //     photo: null,
  //     absenceHistory: [],
  //   },
  //   {
  //     id: 5,
  //     nom: "Monsieur Thomas Bonnet",
  //     matiere: "Anglais",
  //     classes: ["6ème C", "5ème B", "4ème A"],
  //     status: "present",
  //     arrivalTime: "",
  //     photo: null,
  //     absenceHistory: [],
  //   },
  //   {
  //     id: 6,
  //     nom: "Madame Emma Simon",
  //     matiere: "Arts Plastiques",
  //     classes: ["Toutes classes"],
  //     status: "present",
  //     arrivalTime: "",
  //     photo: null,
  //     absenceHistory: [],
  //   },
  //   {
  //     id: 7,
  //     nom: "Monsieur Alexandre Michel",
  //     matiere: "Éducation Physique",
  //     classes: ["Toutes classes"],
  //     status: "absent",
  //     arrivalTime: "",
  //     photo: null,
  //     absenceHistory: [
  //       {
  //         date: "2025-06-18",
  //         status: "absent",
  //         reason: "Non justifiée",
  //         justified: false,
  //       },
  //     ],
  //   },
  //   {
  //     id: 8,
  //     nom: "Madame Léa Garcia",
  //     matiere: "Musique",
  //     classes: ["Toutes classes"],
  //     status: "present",
  //     arrivalTime: "",
  //     photo: null,
  //     absenceHistory: [],
  //   },
  // ];

  // Fonction pour filtrer les élèves
  const filteredStudents = students.filter((student: any) => {
    const matchesSearch =
      student?.nom.toLowerCase().includes(searchQuery.toLowerCase()) ||
      student.prenom?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      student.postnom?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesClass =
      selectedClass === "Toutes les classes" ||
      student.classeDesignation?.toLowerCase() === selectedClass.toLowerCase();

    const matchesStatus =
      statusFilter === "tous" || student.coteEleveId == statusFilter;

    return matchesSearch && matchesClass && matchesStatus;
  });

  // Fonction pour filtrer les personnels
  const filteredTeachers = teachers.filter(
    (
      teacher: PersonalType & {
        cotePersonalId: number;
        coteJustification: string;
        coteId: number;
      }
    ) => {
      // Filtre par recherche
      if (
        searchQuery &&
        !teacher.nom.toLowerCase().includes(searchQuery.toLowerCase())
      )
        return false;
      // Filtre par statut
      if (statusFilter !== "tous" && teacher.cotePersonalId !== statusFilter)
        return false;
      return true;
    }
  );

  // Calcul pour la pagination des élèves
  const totalPages = Math.ceil(filteredStudents.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedStudents = filteredStudents.slice(startIndex, endIndex);

  // Calcul pour la pagination des enseignants
  const totalTeacherPages = Math.ceil(filteredTeachers.length / itemsPerPage);
  const teacherStartIndex = (currentPage - 1) * itemsPerPage;
  const teacherEndIndex = teacherStartIndex + itemsPerPage;
  const paginatedTeachers = filteredTeachers.slice(
    teacherStartIndex,
    teacherEndIndex
  );
  // console.log(students.length);
  // Calcul des statistiques pour les élèves
  const totalStudents =
    selectedClass === "Toutes les classes"
      ? students.length
      : students.filter((s: any) => s.classeDesignation === selectedClass)
          .length;

  const presentStudents =
    selectedClass === "Toutes les classes"
      ? students.filter((s: any) => s.coteEleveId === 1).length //present pour ttes les classes
      : students.filter(
          (s: any) =>
            s.classeDesignation === selectedClass && s.coteEleveId === 1 //presence pour une classe X
        ).length;

  const absentStudents =
    selectedClass === "Toutes les classes"
      ? students.filter((s: any) => s.coteEleveId === 3).length // absent pour ttes les classes
      : students.filter((s: any) => {
          return s.classeDesignation === selectedClass && s.coteEleveId === 3;
        }).length;

  const lateStudents =
    selectedClass === "Toutes les classes"
      ? students.filter((s: any) => s.coteEleveId === 2).length
      : students.filter(
          (s: any) =>
            s.classeDesignation === selectedClass && s.coteEleveId === 2
        ).length;

  const attendanceRate =
    totalStudents > 0
      ? (((presentStudents + lateStudents) / totalStudents) * 100).toFixed(1)
      : 0;

  // Calcul des statistiques pour les enseignants
  const totalTeachers = teachers.length;
  const presentTeachers = teachers.filter(
    (t: PersonalType & { cotePersonalId: number }) => t.cotePersonalId === 1
  ).length;
  const lateTeachers = teachers.filter(
    (t: PersonalType & { cotePersonalId: number }) => t.cotePersonalId === 2
  ).length;
  const absentTeachers = teachers.filter(
    (t: PersonalType & { cotePersonalId: number }) => t.cotePersonalId === 3
  ).length;
  const teacherAttendanceRate =
    totalTeachers > 0
      ? (((presentTeachers + lateTeachers) / totalTeachers) * 100).toFixed(1)
      : 0;

  // Fonction pour ouvrir le modal de justification
  const openJustifyModal = (student: any) => {
    setSelectedStudent(student);
    setIsJustifyModalOpen(true);
  };

  // Fonction pour ouvrir le modal de justification pour enseignant
  const openJustifyTeacherModal = (teacher: any) => {
    setSelectedTeacher(teacher);
    setIsJustifyModalOpen(true);
  };

  // Fonction pour ouvrir le modal de notification
  const openNotifyModal = (student: any) => {
    setSelectedStudent(student);
    setIsNotifyModalOpen(true);
  };

  //Update attendance
  const queryClient = useQueryClient();

  const mutationUpdateAttendanceStudent = useMutation({
    mutationFn: () =>
      studentAttendanceController.update(selectedStudent.coteId, {
        justification: justificationForm.reason,
        cote_eleve_id: selectedStudent.coteEleveId,
      }),
    onSuccess: (data) => {
      setShowNotification(true);
      setNotificationMessage("Justification enregistrée avec succès");
      setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage("");
      }, 3000);

      setIsJustifyModalOpen(false);
      setJustificationForm({
        reason: null,
        currentAttendanceId: null,
        currentAttendanceCoteId: null,
      });

      setSelectedStudent(null);
      setSelectedTeacher(null);

      setSelectedStudent(null);
      queryClient.invalidateQueries({ queryKey: ["studentAttendance"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const mutationUpadateAttenadaceTeacher = useMutation({
    mutationFn: () =>
      studentAttendanceController.update(selectedTeacher.coteId, {
        justification: justificationForm.reason,
        cote_personnel_id: selectedTeacher.cotePersonalId,
      }),
    onSuccess: (data) => {
      setShowNotification(true);
      setNotificationMessage("Justification enregistrée avec succès");
      setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage("");
      }, 3000);

      setIsJustifyModalOpen(false);
      setJustificationForm({
        reason: null,
        currentAttendanceId: null,
        currentAttendanceCoteId: null,
      });

      setSelectedStudent(null);
      setSelectedTeacher(null);

      setSelectedStudent(null);
      queryClient.invalidateQueries({ queryKey: ["studentAttendance"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const handleUpdateAttendance = () => {
    selectedStudent
      ? mutationUpdateAttendanceStudent.mutate()
      : mutationUpadateAttenadaceTeacher.mutate();
  };

  // Fonction pour envoyer une notification
  const handleNotifySubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Dans une application réelle, cela enverrait une notification
    setIsNotifyModalOpen(false);
    // Afficher une notification
    setNotificationMessage("Notification envoyée aux parents avec succès");
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  // Fonction pour basculer le mode sombre
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  // Fonction pour exporter les données
  const exportData = () => {
    let data: any = [];
    if (activeTab === "students") {
      data = paginatedStudents.map((student: any) => ({
        Date: selectedDate,
        Noms: ` ${student.nom} ${student.postnom} ${capitalizeFirstLetter(
          student.prenom
        )}`,
        Classe: student.classeDesignation,
        Cotation:
          student.coteEleveId === 1
            ? "Présent"
            : student.coteEleveId === 2
            ? "Retardataire"
            : "Absent",
      }));
    } else {
      data = paginatedTeachers.map((teacher: any) => ({
        Date: selectedDate,
        Noms: `${teacher.nom} ${teacher.postnom} ${capitalizeFirstLetter(
          teacher.prenom
        )}`,
        Cotation:
          teacher.cotePersonalId === 1
            ? "Présent"
            : teacher.cotePersonalId === 2
            ? "Retardataire"
            : "Absent",
      }));
    }

    // Create Excel-like content
    const headers = Object.keys(data[0]);
    const excelContent = [
      headers.join("\t"),
      ...data.map((row: any) =>
        headers.map((header) => row[header]).join("\t")
      ),
    ].join("\n");
    // Create and trigger download
    const blob = new Blob([excelContent], {
      type: "text/tab-separated-values;charset=utf-8;",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Attendance_${new Date().toISOString().split("T")[0]}.xls`;
    link.click();

    setNotificationMessage("Export Excel réussi");
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  return (
    <div className="ml-60 w-full">
      {/* Header */}

      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />

      {/* Main Content */}
      <main className="p-6 mt-16">
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold mb-1">Gestion des présences</h1>
            <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
              Gérez les informations présences des élèves et des personnels
            </p>
          </div>
          {/* Tab Navigation */}
          <div className="flex gap-3">
            <button
              onClick={() => {
                setActiveTab("students");
                setCurrentPage(1);
                setSearchQuery("");
                setStatusFilter("tous");
              }}
              className={`px-4 py-2 rounded-lg font-medium transition-colors !rounded-button whitespace-nowrap cursor-pointer ${
                activeTab === "students"
                  ? isDarkMode
                    ? "bg-blue-600 text-white"
                    : "bg-blue-500 text-white"
                  : isDarkMode
                  ? "bg-[#161B22] text-gray-300 hover:bg-gray-700"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <i className="fas fa-user-graduate mr-2"></i>
              Présences Élèves
            </button>
            <button
              onClick={() => {
                setActiveTab("teachers");
                setCurrentPage(1);
                setSearchQuery("");
                setStatusFilter("tous");
              }}
              className={`px-4 py-2 rounded-lg font-medium transition-colors !rounded-button whitespace-nowrap cursor-pointer ${
                activeTab === "teachers"
                  ? isDarkMode
                    ? "bg-blue-600 text-white"
                    : "bg-blue-500 text-white"
                  : isDarkMode
                  ? "bg-[#161B22] text-gray-300 hover:bg-gray-700"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <i className="fas fa-chalkboard-teacher mr-2"></i>
              Présences Enseignants
            </button>
          </div>
        </div>
        {/* Filters and Actions */}
        <div className="flex flex-wrap justify-between items-center mb-6">
          <div className="flex flex-wrap items-center space-x-4 mb-4 lg:mb-0">
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Date
              </label>
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className={`px-3 py-2 rounded-md border ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700 text-white"
                    : "bg-white border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
            </div>
            {activeTab === "students" && (
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Classe
                </label>
                <div className="relative">
                  <select
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.target.value)}
                    className={`appearance-none pl-3 pr-10 py-1 rounded-md border ${
                      isDarkMode
                        ? "bg-[#161B22] border-gray-700 text-white"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  >
                    <option value="Toutes les classes">
                      Toutes les classes
                    </option>
                    {dataClasses.map((classe) => (
                      <option key={classe.id} value={classe.designation}>
                        {classe.designation}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-wrap items-center space-x-2">
            <button
              onClick={exportData}
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-file-export mr-2"></i>
              <span>Exporter</span>
              {/* <i className="fas fa-chevron-down ml-2"></i> */}
            </button>
            {/* <button
              // onClick={printData}
              onClick={handlePrint}
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-print mr-2"></i>
              <span>Imprimer</span>
            </button> */}
          </div>
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          <div
            className={`rounded-lg border ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            } overflow-hidden p-4 flex flex-col items-center`}
          >
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center ${
                isDarkMode ? "bg-blue-900" : "bg-blue-100"
              } text-blue-500 mb-3`}
            >
              <i
                className={`fas ${
                  activeTab === "students"
                    ? "fa-users"
                    : "fa-chalkboard-teacher"
                }`}
              ></i>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              } mb-1`}
            >
              Total des {activeTab === "students" ? "élèves" : "enseignants"}
            </p>
            <p className="text-2xl font-bold">
              {activeTab === "students" ? totalStudents : totalTeachers}
            </p>
          </div>
          <div
            className={`rounded-lg border ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            } overflow-hidden p-4 flex flex-col items-center`}
          >
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center ${
                isDarkMode ? "bg-green-900" : "bg-green-100"
              } text-green-500 mb-3`}
            >
              <i className="fas fa-check-circle"></i>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              } mb-1`}
            >
              Taux de présence
            </p>
            <p className="text-2xl font-bold">
              {activeTab === "students"
                ? attendanceRate
                : teacherAttendanceRate}
              %
            </p>
          </div>
          <div
            className={`rounded-lg border ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            } overflow-hidden p-4 flex flex-col items-center`}
          >
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center ${
                isDarkMode ? "bg-red-900" : "bg-red-100"
              } text-red-500 mb-3`}
            >
              <i className="fas fa-times-circle"></i>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              } mb-1`}
            >
              Absents
            </p>
            <p className="text-2xl font-bold">
              {activeTab === "students" ? absentStudents : absentTeachers}
            </p>
          </div>
          <div
            className={`rounded-lg border ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            } overflow-hidden p-4 flex flex-col items-center`}
          >
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center ${
                isDarkMode ? "bg-yellow-900" : "bg-yellow-100"
              } text-yellow-500 mb-3`}
            >
              <i className="fas fa-clock"></i>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              } mb-1`}
            >
              En retard
            </p>
            <p className="text-2xl font-bold">
              {activeTab === "students" ? lateStudents : lateTeachers}
            </p>
          </div>
        </div>

        {/* Student List */}
        {activeTab === "students" && (
          <div
            className={`rounded-lg border ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            } overflow-hidden mb-6`}
          >
            <div
              className={`px-4 py-3 ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex flex-wrap justify-between items-center`}
            >
              <h3 className="font-medium">
                Liste des élèves -{" "}
                {selectedClass === "all" ? "Toutes les classes" : selectedClass}
              </h3>
              <div className="flex flex-wrap items-center mt-2 sm:mt-0">
                <div className="relative mr-2">
                  <div
                    className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
                  >
                    <i className="fas fa-search"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="Rechercher un élève..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className={`pl-10 pr-4 py-2 rounded-md text-sm ${
                      isDarkMode
                        ? "bg-[#161B22] border-gray-700"
                        : "bg-white border-gray-300"
                    } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                </div>
                <div className="flex space-x-1 mt-2 sm:mt-0">
                  <button
                    onClick={() => setStatusFilter("tous")}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === "tous"
                        ? isDarkMode
                          ? "bg-blue-600 text-white"
                          : "bg-blue-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Tous
                  </button>
                  <button
                    onClick={() => setStatusFilter(1)}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === 1
                        ? isDarkMode
                          ? "bg-green-600 text-white"
                          : "bg-green-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Présents
                  </button>
                  <button
                    onClick={() => setStatusFilter(3)}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === 3
                        ? isDarkMode
                          ? "bg-red-600 text-white"
                          : "bg-red-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Absents
                  </button>
                  <button
                    onClick={() => setStatusFilter(2)}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === 2
                        ? isDarkMode
                          ? "bg-yellow-600 text-white"
                          : "bg-yellow-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Retards
                  </button>
                </div>
              </div>
            </div>
            {/* Pagination */}
            {totalPages > 1 && (
              <div
                className={`px-4 py-3 border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-between items-center`}
              >
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Affichage {startIndex + 1} à{" "}
                  {Math.min(endIndex, filteredStudents.length)} sur{" "}
                  {filteredStudents.length} élèves
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                    className={`px-3 py-1 rounded-md text-sm ${
                      currentPage === 1
                        ? isDarkMode
                          ? "bg-gray-800 text-gray-500 cursor-not-allowed"
                          : "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600 text-white"
                        : "bg-gray-200 hover:bg-gray-300 text-gray-700"
                    } !rounded-button whitespace-nowrap`}
                  >
                    <i className="fas fa-chevron-left mr-1"></i>
                    Précédent
                  </button>
                  <div className="flex space-x-1">
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      let pageNum;
                      if (totalPages <= 5) {
                        pageNum = i + 1;
                      } else if (currentPage <= 3) {
                        pageNum = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        pageNum = totalPages - 4 + i;
                      } else {
                        pageNum = currentPage - 2 + i;
                      }
                      return (
                        <button
                          key={pageNum}
                          onClick={() => setCurrentPage(pageNum)}
                          className={`px-3 py-1 rounded-md text-sm ${
                            currentPage === pageNum
                              ? isDarkMode
                                ? "bg-blue-600 text-white"
                                : "bg-blue-500 text-white"
                              : isDarkMode
                              ? "bg-gray-700 hover:bg-gray-600 text-white"
                              : "bg-gray-200 hover:bg-gray-300 text-gray-700"
                          } !rounded-button whitespace-nowrap`}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                  </div>
                  <button
                    onClick={() =>
                      setCurrentPage(Math.min(totalPages, currentPage + 1))
                    }
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1 rounded-md text-sm ${
                      currentPage === totalPages
                        ? isDarkMode
                          ? "bg-gray-800 text-gray-500 cursor-not-allowed"
                          : "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600 text-white"
                        : "bg-gray-200 hover:bg-gray-300 text-gray-700"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Suivant
                    <i className="fas fa-chevron-right ml-1"></i>
                  </button>
                </div>
              </div>
            )}
            <div className="overflow-x-auto print-area" ref={printRef}>
              {/* <div className="print-header">
                <img src="/" alt="Logo de l'école" className="print-logo" />
                <h1>École Secondaire ETPM</h1>
                <p>Date d’impression : {new Date().toLocaleDateString()}</p>
                <hr />
              </div> */}
              <table className="min-w-full divide-y divide-gray-700 student-table">
                <thead
                  className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
                >
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                    >
                      Élève
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                    >
                      Classe
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Statut
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Justification
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Heure d'arrivée
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody
                  className={`${
                    isDarkMode ? "bg-[#0D1117]" : "bg-white"
                  } divide-y ${
                    isDarkMode ? "divide-gray-700" : "divide-gray-200"
                  }`}
                >
                  {paginatedStudents.map((student: any, index: number) => (
                    <tr
                      key={student.id}
                      className={`${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      } `}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div
                            className={`w-10 h-10 rounded-full flex items-center justify-center ${
                              isDarkMode ? "bg-gray-700" : "bg-gray-200"
                            } text-gray-500`}
                          >
                            <span>
                              {student.nom
                                .split(" ")
                                .map((n: any) => n[0])
                                .join("")}
                            </span>
                          </div>
                          <div className="ml-4">
                            <div
                              className={`${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              } font-medium`}
                            >
                              {`${student.nom} ${
                                student.postnom
                              } ${capitalizeFirstLetter(student.prenom)} 
                              `}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 py-1 text-xs font-semibold rounded-full ${
                            isDarkMode ? "bg-gray-700" : "bg-gray-200"
                          }`}
                        >
                          {student.classeDesignation || <span>-</span>}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-2">
                          <button
                            // onClick={() =>
                            //   changeStudentStatus(student.id, "present")
                            // }
                            className={`p-2 rounded-full ${
                              student.coteEleveId === 1
                                ? "bg-green-500 text-white"
                                : isDarkMode
                                ? "bg-gray-700 text-gray-300"
                                : "bg-gray-200 text-gray-600"
                            } !rounded-button whitespace-nowrap cursor-pointer`}
                            title="Présent"
                          >
                            <i className="fas fa-check"></i>
                          </button>
                          <button
                            // onClick={() =>
                            //   changeStudentStatus(student.id, "absent")
                            // }
                            className={`p-2 rounded-full ${
                              student.coteEleveId === 3
                                ? "bg-red-500 text-white"
                                : isDarkMode
                                ? "bg-gray-700 text-gray-300"
                                : "bg-gray-200 text-gray-600"
                            } !rounded-button whitespace-nowrap cursor-pointer`}
                            title="Absent"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                          <button
                            // onClick={() =>
                            //   changeStudentStatus(student.id, "late")
                            // }
                            className={`p-2 rounded-full ${
                              student.coteEleveId === 2
                                ? "bg-yellow-500 text-white"
                                : isDarkMode
                                ? "bg-gray-700 text-gray-300"
                                : "bg-gray-200 text-gray-600"
                            } !rounded-button whitespace-nowrap cursor-pointer`}
                            title="En retard"
                          >
                            <i className="fas fa-clock"></i>
                          </button>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-2">
                          {student.coteJustification || <span>-</span>}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        {student.coteEleveId === 2 ||
                        student.coteEleveId === 1 ? (
                          <span
                            className={`px-2 py-1 rounded-md border ${
                              isDarkMode
                                ? "bg-[#161B22] border-gray-700 text-white"
                                : "bg-white border-gray-300"
                            } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                          >
                            {moment(student.coteCreatedAt).format("HH:mm")}
                          </span>
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-2">
                          {(student.coteEleveId === 3 ||
                            student.coteEleveId === 2) && (
                            <>
                              <button
                                onClick={() => openJustifyModal(student)}
                                className={`p-2 rounded-full ${
                                  isDarkMode
                                    ? "hover:bg-gray-700"
                                    : "hover:bg-gray-200"
                                } text-blue-500 !rounded-button whitespace-nowrap cursor-pointer`}
                                title="Justifier"
                              >
                                <i className="fas fa-file-alt"></i>
                              </button>
                              <button
                                onClick={() => openNotifyModal(student)}
                                className={`p-2 rounded-full ${
                                  isDarkMode
                                    ? "hover:bg-gray-700"
                                    : "hover:bg-gray-200"
                                } text-orange-500 !rounded-button whitespace-nowrap cursor-pointer`}
                                title="Notifier les parents"
                              >
                                <i className="fas fa-envelope"></i>
                              </button>
                            </>
                          )}
                          {student.coteEleveId === 1 && (
                            <button
                              disabled
                              // onClick={() => {
                              //   setSelectedStudent(student);
                              //   setIsHistoryModalOpen(true);
                              // }}
                              className={`p-2 rounded-full ${
                                isDarkMode
                                  ? "hover:bg-gray-700"
                                  : "hover:bg-gray-200"
                              } text-purple-500 !rounded-button whitespace-nowrap cursor-pointer`}
                              title="Historique"
                            >
                              <i className="fa-solid fa-circle-check text-green-500"></i>{" "}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Teacher List */}
        {activeTab === "teachers" && (
          <div
            className={`rounded-lg border ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            } overflow-hidden mb-6`}
          >
            <div
              className={`px-4 py-3 ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex flex-wrap justify-between items-center`}
            >
              <h3 className="font-medium">Liste des enseignants</h3>
              <div className="flex flex-wrap items-center mt-2 sm:mt-0">
                <div className="relative mr-2">
                  <div
                    className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
                  >
                    <i className="fas fa-search"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="Rechercher un enseignant..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className={`pl-10 pr-4 py-2 rounded-md text-sm ${
                      isDarkMode
                        ? "bg-[#161B22] border-gray-700"
                        : "bg-white border-gray-300"
                    } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                </div>
                <div className="flex space-x-1 mt-2 sm:mt-0">
                  <button
                    onClick={() => setStatusFilter("tous")}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === "tous"
                        ? isDarkMode
                          ? "bg-blue-600 text-white"
                          : "bg-blue-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Tous
                  </button>
                  <button
                    onClick={() => setStatusFilter("present")}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === "present"
                        ? isDarkMode
                          ? "bg-green-600 text-white"
                          : "bg-green-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Présents
                  </button>
                  <button
                    onClick={() => setStatusFilter("absent")}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === "absent"
                        ? isDarkMode
                          ? "bg-red-600 text-white"
                          : "bg-red-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Absents
                  </button>
                  <button
                    onClick={() => setStatusFilter("late")}
                    className={`px-3 py-1 rounded-md text-sm ${
                      statusFilter === "late"
                        ? isDarkMode
                          ? "bg-yellow-600 text-white"
                          : "bg-yellow-500 text-white"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Retards
                  </button>
                </div>
              </div>
            </div>
            {/* Teacher Pagination */}
            {totalTeacherPages > 1 && (
              <div
                className={`px-4 py-3 border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-between items-center`}
              >
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Affichage {teacherStartIndex + 1} à{" "}
                  {Math.min(teacherEndIndex, filteredTeachers.length)} sur{" "}
                  {filteredTeachers.length} enseignants
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                    className={`px-3 py-1 rounded-md text-sm ${
                      currentPage === 1
                        ? isDarkMode
                          ? "bg-gray-800 text-gray-500 cursor-not-allowed"
                          : "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600 text-white"
                        : "bg-gray-200 hover:bg-gray-300 text-gray-700"
                    } !rounded-button whitespace-nowrap`}
                  >
                    <i className="fas fa-chevron-left mr-1"></i>
                    Précédent
                  </button>
                  <div className="flex space-x-1">
                    {Array.from(
                      { length: Math.min(5, totalTeacherPages) },
                      (_, i) => {
                        let pageNum;
                        if (totalTeacherPages <= 5) {
                          pageNum = i + 1;
                        } else if (currentPage <= 3) {
                          pageNum = i + 1;
                        } else if (currentPage >= totalTeacherPages - 2) {
                          pageNum = totalTeacherPages - 4 + i;
                        } else {
                          pageNum = currentPage - 2 + i;
                        }
                        return (
                          <button
                            key={pageNum}
                            onClick={() => setCurrentPage(pageNum)}
                            className={`px-3 py-1 rounded-md text-sm ${
                              currentPage === pageNum
                                ? isDarkMode
                                  ? "bg-blue-600 text-white"
                                  : "bg-blue-500 text-white"
                                : isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600 text-white"
                                : "bg-gray-200 hover:bg-gray-300 text-gray-700"
                            } !rounded-button whitespace-nowrap`}
                          >
                            {pageNum}
                          </button>
                        );
                      }
                    )}
                  </div>
                  <button
                    onClick={() =>
                      setCurrentPage(
                        Math.min(totalTeacherPages, currentPage + 1)
                      )
                    }
                    disabled={currentPage === totalTeacherPages}
                    className={`px-3 py-1 rounded-md text-sm ${
                      currentPage === totalTeacherPages
                        ? isDarkMode
                          ? "bg-gray-800 text-gray-500 cursor-not-allowed"
                          : "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600 text-white"
                        : "bg-gray-200 hover:bg-gray-300 text-gray-700"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Suivant
                    <i className="fas fa-chevron-right ml-1"></i>
                  </button>
                </div>
              </div>
            )}
            <div className="overflow-x-auto ">
              <table className="min-w-full divide-y divide-gray-700 mb-12">
                <thead
                  className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
                >
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                    >
                      Enseignant
                    </th>

                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Statut
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Justification
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Heure d'arrivée
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody
                  className={`${
                    isDarkMode ? "bg-[#0D1117]" : "bg-white"
                  } divide-y ${
                    isDarkMode ? "divide-gray-700" : "divide-gray-200"
                  }`}
                >
                  {paginatedTeachers.map(
                    (
                      teacher: PersonalType & {
                        cotePersonalId: number;
                        coteJustification: string;
                        coteId: number;
                        coteCreatedAt: string;
                      }
                    ) => (
                      <tr
                        key={teacher.id}
                        className={`${
                          isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                        }`}
                      >
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div
                              className={`w-10 h-10 rounded-full flex items-center justify-center ${
                                isDarkMode ? "bg-gray-700" : "bg-gray-200"
                              } text-gray-500`}
                            >
                              {
                                <span>
                                  {teacher.nom
                                    .split(" ")
                                    .map((n) => n[0])
                                    .join("")}
                                </span>
                              }
                            </div>
                            <div className="ml-4">
                              <div
                                className={`${
                                  isDarkMode ? "text-gray-300" : "text-gray-700"
                                } font-medium`}
                              >
                                {`${teacher.nom} ${
                                  teacher.postnom
                                } ${capitalizeFirstLetter(teacher.prenom)}`}
                              </div>
                            </div>
                          </div>
                        </td>

                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <button
                              // onClick={() =>
                              //   changeTeacherStatus(teacher.id, "present")
                              // }
                              className={`p-2 rounded-full ${
                                teacher.cotePersonalId === 1
                                  ? "bg-green-500 text-white"
                                  : isDarkMode
                                  ? "bg-gray-700 text-gray-300"
                                  : "bg-gray-200 text-gray-600"
                              } !rounded-button whitespace-nowrap cursor-pointer`}
                              title="Présent"
                            >
                              <i className="fas fa-check"></i>
                            </button>
                            <button
                              // onClick={() =>
                              //   changeTeacherStatus(teacher.id, "absent")
                              // }
                              className={`p-2 rounded-full ${
                                teacher.cotePersonalId === 3
                                  ? "bg-red-500 text-white"
                                  : isDarkMode
                                  ? "bg-gray-700 text-gray-300"
                                  : "bg-gray-200 text-gray-600"
                              } !rounded-button whitespace-nowrap cursor-pointer`}
                              title="Absent"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                            <button
                              // onClick={() =>
                              //   changeTeacherStatus(teacher.id, "late")
                              // }
                              className={`p-2 rounded-full ${
                                teacher.cotePersonalId === 2
                                  ? "bg-yellow-500 text-white"
                                  : isDarkMode
                                  ? "bg-gray-700 text-gray-300"
                                  : "bg-gray-200 text-gray-600"
                              } !rounded-button whitespace-nowrap cursor-pointer`}
                              title="En retard"
                            >
                              <i className="fas fa-clock"></i>
                            </button>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            {teacher.coteJustification || <span>-</span>}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          {teacher.cotePersonalId === 2 ||
                          teacher.cotePersonalId === 1 ? (
                            <span
                              className={`px-2 py-1 rounded-md border ${
                                isDarkMode
                                  ? "bg-[#161B22] border-gray-700 text-white"
                                  : "bg-white border-gray-300"
                              } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                              {moment(teacher.coteCreatedAt).format("HH:mm")}
                            </span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            {(teacher.cotePersonalId === 3 ||
                              teacher.cotePersonalId === 2) && (
                              <button
                                onClick={() => openJustifyTeacherModal(teacher)}
                                className={`p-2 rounded-full ${
                                  isDarkMode
                                    ? "hover:bg-gray-700"
                                    : "hover:bg-gray-200"
                                } text-blue-500 !rounded-button whitespace-nowrap cursor-pointer`}
                                title="Justifier"
                              >
                                <i className="fas fa-file-alt"></i>
                              </button>
                            )}
                            {teacher.cotePersonalId === 1 && (
                              <button
                                disabled
                                // onClick={() => {
                                //   setSelectedStudent(student);
                                //   setIsHistoryModalOpen(true);
                                // }}
                                className={`p-2 rounded-full ${
                                  isDarkMode
                                    ? "hover:bg-gray-700"
                                    : "hover:bg-gray-200"
                                } text-purple-500 !rounded-button whitespace-nowrap cursor-pointer`}
                                title="Historique"
                              >
                                <i className="fa-solid fa-circle-check text-green-500"></i>{" "}
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Bottom Action Bar */}
        <div
          className={`fixed bottom-0 left-60 right-0 py-3 px-6 border-t ${
            isDarkMode
              ? "bg-[#0D1117] border-gray-700"
              : "bg-white border-gray-200"
          } flex justify-between items-center`}
        >
          <div>
            <span
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              Date du jour: {moment().format("DD/MM/YYYY")}
            </span>
          </div>
          <div className="flex space-x-3">ChikSoft v2.0.1</div>
        </div>
      </main>
      {/* Justify Modal */}
      {isJustifyModalOpen && (selectedStudent || selectedTeacher) && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => {
              setIsJustifyModalOpen(false);
              setSelectedStudent(null);
              setSelectedTeacher(null);
            }}
          ></div>
          <div
            className={`relative w-full max-w-md p-6 rounded-lg shadow-xl ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <h3 className="text-xl font-semibold mb-4">
              Justifier{" "}
              {(selectedStudent?.coteEleveId ||
                selectedTeacher?.cotePersonnelId) === 2
                ? "le retard"
                : "l'absence"}
            </h3>
            <div>
              <div className="mb-4">
                <div className="flex items-center mb-3">
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-gray-700" : "bg-gray-200"
                    } text-gray-500 mr-3`}
                  >
                    <span>
                      {(selectedStudent?.nom || selectedTeacher?.nom)
                        ?.split(" ")
                        .map((n: any) => n[0])
                        .join("")}
                    </span>
                  </div>
                  <div>
                    <p className="font-medium">
                      {selectedStudent?.nom ||
                        `${selectedTeacher?.nom} ${selectedTeacher?.postnom}`}
                    </p>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      {selectedStudent
                        ? `${selectedStudent.classeDesignation} • ${selectedDate}`
                        : ` `}
                    </p>
                  </div>
                </div>
                <div
                  className={`p-3 rounded-lg mb-4 ${
                    (selectedStudent?.status || selectedTeacher?.status) ===
                    "absent"
                      ? isDarkMode
                        ? "bg-red-900 bg-opacity-20"
                        : "bg-red-50"
                      : isDarkMode
                      ? "bg-yellow-900 bg-opacity-20"
                      : "bg-yellow-50"
                  } border ${
                    (selectedStudent?.status || selectedTeacher?.status) ===
                    "absent"
                      ? isDarkMode
                        ? "border-red-800"
                        : "border-red-100"
                      : isDarkMode
                      ? "border-yellow-800"
                      : "border-yellow-100"
                  }`}
                >
                  <div className="flex items-center">
                    <i
                      className={`fas ${
                        (selectedStudent?.status || selectedTeacher?.status) ===
                        "absent"
                          ? "fa-times-circle text-red-500"
                          : "fa-clock text-yellow-500"
                      } mr-2`}
                    ></i>
                    <p
                      className={`${
                        (selectedStudent?.coteEleveId ||
                          selectedTeacher?.cotePersonnelId) === 3
                          ? isDarkMode
                            ? "text-red-300"
                            : "text-red-800"
                          : isDarkMode
                          ? "text-yellow-300"
                          : "text-yellow-800"
                      }`}
                    >
                      {(selectedStudent?.coteId || selectedTeacher?.coteId) ==
                      null
                        ? "Aucune activité "
                        : (selectedStudent?.coteEleveId ||
                            selectedTeacher?.cotePersonnelId) === 3
                        ? "Absent "
                        : "En retard "}
                      le {selectedDate.split("-").reverse().join("/")}
                      {(selectedStudent?.coteEleveId ||
                        selectedTeacher?.cotePersonnelId) === 2 &&
                      (selectedStudent?.created_at ||
                        selectedTeacher?.created_at)
                        ? ` (Arrivée à ${
                            moment(selectedStudent?.created_at).format(
                              "HH:mm"
                            ) ||
                            moment(selectedTeacher?.created_at).format("HH:mm")
                          })`
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Motif de justification
                </label>
                <select
                  value={justificationForm.reason}
                  onChange={(e) =>
                    setJustificationForm((prev) => ({
                      ...prev,
                      reason: e.target.value,
                    }))
                  }
                  className={`w-full px-3 py-1 rounded-md border ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700 text-white"
                      : "bg-white border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  required
                >
                  <option value="">Sélectionner un motif</option>
                  <option value="Maladie">Maladie</option>
                  <option value="Rendez-vous médical">
                    Rendez-vous médical
                  </option>
                  <option value="Problème familial">Problème familial</option>
                  <option value="Transport">Problème de transport</option>
                  {selectedTeacher && (
                    <option value="Formation">Formation</option>
                  )}
                  {selectedTeacher && <option value="Réunion">Réunion</option>}
                  <option value="Autre">Autre</option>
                </select>
              </div>
              {/* <div className="mb-4">
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Détails
                </label>
                <textarea
                  value={justificationForm.details}
                  onChange={(e) =>
                    setJustificationForm((prev) => ({
                      ...prev,
                      details: e.target.value,
                    }))
                  }
                  rows={3}
                  className={`w-full px-3 py-2 rounded-md border ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700 text-white"
                      : "bg-white border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                ></textarea>
              </div> */}

              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  disabled={
                    mutationUpdateAttendanceStudent.isPending ||
                    mutationUpadateAttenadaceTeacher.isPending
                  }
                  onClick={() => {
                    setIsJustifyModalOpen(false);
                    setSelectedStudent(null);
                    setSelectedTeacher(null);
                  }}
                  className={`px-4 py-2 rounded-md ${
                    (mutationUpdateAttendanceStudent.isPending ||
                      mutationUpadateAttenadaceTeacher.isPending) &&
                    "cursor-not-allowed"
                  } ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-200 hover:bg-gray-300"
                  } !rounded-button whitespace-nowrap`}
                >
                  Annuler
                </button>
                <button
                  disabled={
                    mutationUpdateAttendanceStudent.isPending ||
                    mutationUpadateAttenadaceTeacher.isPending ||
                    selectedStudent?.coteId === null ||
                    selectedTeacher?.coteId === null
                  }
                  onClick={() => {
                    handleUpdateAttendance();
                  }}
                  className={`px-4 py-2 ${
                    mutationUpdateAttendanceStudent.isPending ||
                    mutationUpadateAttenadaceTeacher.isPending ||
                    selectedStudent?.coteId === null ||
                    selectedTeacher?.coteId === null
                      ? "cursor-not-allowed  bg-blue-400"
                      : "cursor-pointer  bg-blue-500 hover:bg-blue-700"
                  } rounded-md text-white !rounded-button whitespace-nowrap`}
                >
                  {mutationUpdateAttendanceStudent.isPending ||
                  mutationUpadateAttenadaceTeacher.isPending
                    ? "Chargement..."
                    : "Mettre à jour"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Notify Modal */}
      {isNotifyModalOpen && selectedStudent && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setIsNotifyModalOpen(false)}
          ></div>
          <div
            className={`relative w-full max-w-md p-6 rounded-lg shadow-xl ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <h3 className="text-xl font-semibold mb-4">Notifier les parents</h3>
            <form onSubmit={handleNotifySubmit}>
              <div className="mb-4">
                <div className="flex items-center mb-3">
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-gray-700" : "bg-gray-200"
                    } text-gray-500 mr-3`}
                  >
                    <span>
                      {selectedStudent.nom
                        .split(" ")
                        .map((n: any) => n[0])
                        .join("")}
                    </span>
                  </div>
                  <div>
                    <p className="font-medium">{selectedStudent.nom}</p>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      {selectedStudent.classe} • {selectedDate}
                    </p>
                  </div>
                </div>
                <div
                  className={`p-3 rounded-lg mb-4 ${
                    selectedStudent.coteEleveId === 3
                      ? isDarkMode
                        ? "bg-red-900 bg-opacity-20"
                        : "bg-red-50"
                      : isDarkMode
                      ? "bg-yellow-900 bg-opacity-20"
                      : "bg-yellow-50"
                  } border ${
                    selectedStudent.coteEleveId === 3
                      ? isDarkMode
                        ? "border-red-800"
                        : "border-red-100"
                      : isDarkMode
                      ? "border-yellow-800"
                      : "border-yellow-100"
                  }`}
                >
                  <div className="flex items-center">
                    <i
                      className={`fas ${
                        selectedStudent.coteEleveId === 3
                          ? "fa-times-circle text-red-500"
                          : "fa-clock text-yellow-500"
                      } mr-2`}
                    ></i>
                    <p
                      className={`${
                        selectedStudent.coteEleveId === 3
                          ? isDarkMode
                            ? "text-red-300"
                            : "text-red-800"
                          : isDarkMode
                          ? "text-yellow-300"
                          : "text-yellow-800"
                      }`}
                    >
                      {selectedStudent.coteEleveId === 3
                        ? "Absent"
                        : "En retard"}{" "}
                      le {selectedDate.split("-").reverse().join("/")}
                      {selectedStudent.coteEleveId === 2 &&
                      selectedStudent.arrivalTime
                        ? ` (Arrivée à ${selectedStudent.arrivalTime})`
                        : ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Sujet
                </label>
                <input
                  type="text"
                  value={`Notification ${
                    selectedStudent.coteEleveId === 3
                      ? "d'absence"
                      : "de retard"
                  } - ${selectedStudent.nom}`}
                  readOnly
                  className={`w-full px-3 py-2 rounded-md border ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700 text-white"
                      : "bg-white border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                />
              </div>
              <div className="mb-4">
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Message
                </label>
                <textarea
                  rows={5}
                  defaultValue={`Madame, Monsieur,\n\nNous vous informons que votre enfant ${
                    selectedStudent.nom
                  } a été ${
                    selectedStudent.coteEleveId === 3 ? "absent" : "en retard"
                  } le ${selectedDate
                    .split("-")
                    .reverse()
                    .join(
                      "/"
                    )}.\n\nNous vous prions de bien vouloir nous fournir un justificatif dans les plus brefs délais.\n\nCordialement,\nL'administration`}
                  className={`w-full px-3 py-2 rounded-md border ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700 text-white"
                      : "bg-white border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                ></textarea>
              </div>
              <div className="mb-4">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <span
                    className={`ml-2 text-sm ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Envoyer également par SMS
                  </span>
                </label>
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setIsNotifyModalOpen(false)}
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-200 hover:bg-gray-300"
                  } !rounded-button whitespace-nowrap`}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className={`px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white !rounded-button whitespace-nowrap`}
                >
                  Envoyer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Notification */}
      {showNotification && (
        <div className="fixed bottom-4 right-4 z-50">
          <div
            className={`px-4 py-3 rounded-lg shadow-lg ${
              isDarkMode ? "bg-green-900" : "bg-green-100"
            } border ${isDarkMode ? "border-green-800" : "border-green-200"}`}
          >
            <div className="flex items-center">
              <i className="fas fa-check-circle text-green-500 mr-2"></i>
              <p
                className={`${
                  isDarkMode ? "text-green-100" : "text-green-800"
                }`}
              >
                {notificationMessage}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Attendance;
